<template>
  <div class="hello" style="background-color: #E8E8E8; min-height: 100vh;">
    <div style="padding: 10px 10px;">
      <!-- <form action="/">
        <van-search
          v-model="value"
          placeholder="请输入搜索关键词"
          @search="onSearch"
          @clear="onClear"
        />
      </form> -->

      <div style="background-color: #fff; margin-top: 10px; padding: 10px 10px 10px 0px;position: relative;border-radius: 4px;">
        <van-row type="flex" justify="end">
          <van-col span="4">
            <select v-model="selectYear" @change="selectChange($event)" class="selectClass" >
              <option v-for="(item,index) in selectYearsColumns" :key="index" :value="item">
                  {{item}}
              </option>
            </select>
          </van-col>
        </van-row>
      </div>
      
      <div style="background-color: #fff; margin-top: 10px; padding: 10px 0px;position: relative;border-radius: 4px;">
        <!-- 图表 -->
        <div id="charts1" style="width: 100%; height: 200px;"></div>
        <van-tag round color="rgb(46, 204, 190)" style="position: absolute; right: 10px; top: 20px;text-align:center;font-size: 10px" @click="chartClick(2)">正常({{charts[0].value}})</van-tag>
        <van-tag round color="rgb(86, 170, 255)" style="position: absolute; right: 10px; top: 60px;text-align:center;font-size: 10px" @click="chartClick(3)">超前({{charts[1].value}})</van-tag>
        <van-tag round color="rgb(243, 115, 68)" style="position: absolute; right: 10px; top: 100px;text-align:center;font-size: 10px" @click="chartClick(1)">滞后({{charts[2].value}})</van-tag>
        <van-tag round color="rgb(150, 150, 150)" style="position: absolute; right: 10px; top: 140px;text-align:center;font-size: 10px" @click="chartClick(4)">办结({{charts[3].value}})</van-tag>
        <div style="position: absolute; right: 10px; bottom: 10px;">
          <span style="color: #000; font-weight: 800; font-size: 10px">项目总数：</span>
          <span style="color: #000; font-weight: 200; font-size: 10px">{{subtotal}}项</span>
        </div>
      </div>
      <div style="background-color: #fff; margin-top: 10px; padding: 10px 0px;border-radius: 4px;">
        <van-collapse v-if="totalproject.length > 0" v-model="activeNames" accordion>
          <van-collapse-item :title="item.name" :name="index" style="text-align:left;" v-for="item,index in totalproject" :key="index">
            <div @click="clickMethod(item.id)">
              <div style="color: #fff;margin: 0px 30px;border-radius: 16px;overflow: hidden;">
                <span :style="'width:' + item.zcshow + '%; background-color: rgb(46, 204, 190);float:left;text-align:center;'">{{item.zccount}}</span>
                <span :style="'width:' + item.cqshow + '%; background-color: rgb(86, 170, 255);float:left;text-align:center;'">{{item.cqcount}}</span>
                <span :style="'width:' + item.zhshow + '%; background-color: rgb(243, 115, 68);float:left;text-align:center;'">{{item.zhcount}}</span>
                <span :style="'width:' + item.ybjshow + '%; background-color: rgb(150, 150, 150);float:left;text-align:center;'">{{item.ybjcount}}</span>
              </div>
              <van-row type="flex" justify="space-between" style="margin: 10px 30px;flex-wrap: wrap;">
                <van-col span="12">子项目：{{item.totalCount}}个</van-col>
                <van-col span="12">已办结：{{item.ybjcount}}个</van-col>
                <!-- <van-col span="24">牵头单位：{{item.qtdw}}</van-col> -->
              </van-row>
            </div>
          </van-collapse-item>
        </van-collapse>
        <div v-else>当前无记录</div>
      </div>
      <div style="height: 100px;"></div>
    </div>
  </div>
</template>

<script>
let Echarts = require('echarts/lib/echarts'); //基础实例 注意不要使用import
require('echarts/lib/chart/pie'); //按需引入 bar = 柱状图
require('echarts/lib/component/title');
require('echarts/lib/component/tooltip');
require('echarts/lib/component/legend');
require('echarts/lib/component/toolbox');
import zdqdUser from '../api/zdqd'
import {getDict} from '../api/zdqd.js'
export default {
  name: 'Zdqd',
  data () {
    return {
      chart: null,
      value: '',
      activeNames: '',
      totalproject: [],
      initTotalproject: [],
      subtotal: 0,
      charts: [0,0,0,0],
      subprojects: [],
      selectYearsColumns:[],
      selectYear:process.env.VUE_SELECT_YEAR
    }
  },
  created () {
    // 通过后台配置的字典，拿到年份
    getDict("selectyear_list").then((res) => {
      res.data.content.forEach(x => {
        this.selectYearsColumns.push(x.label)
        this.selectYear = new Date().getFullYear()
      })
    })

    this.initMethod(this.selectYear)
  },
  destroyed(){
    this.chart = null
  },
  methods: {
    initMethod(selectYear) {
      zdqdUser.getAllList(selectYear).then(res => {
        this.totalproject = res.data.totalproject
        this.subtotal = res.data.subtotal
        this.charts = res.data.charts
        this.subprojects = res.data.subprojects
        this.totalproject.forEach(item => {
          item.zcshow = item.totalCount == 0 ? 100 : (100*item.zccount/item.totalCount).toFixed(2)
          item.cqshow = item.totalCount ==0 ? 0 : (100*item.cqcount/item.totalCount).toFixed(2)
          item.zhshow = item.totalCount ==0 ? 0 : (100*item.zhcount/item.totalCount).toFixed(2)
          item.ybjshow = item.totalCount ==0 ? 0 : (100*item.ybjcount/item.totalCount).toFixed(2)
        })
        this.initTotalproject = this.totalproject
        // alert(this.totalproject[0].cqshow)
        setTimeout(() =>{
          this.init()
        },100);
      })
    },
    selectChange(e) {
      this.initMethod(e.target.value)
    },


    init() {
      var that = this
      //2.初始化
      const LC = document.getElementById("charts1")
      this.chart = Echarts.init(LC)
      //3.配置数据
      let option = {
        title: {
          text: "重点清单统计图",
          x: "center",
          textStyle: {
              fontSize: 16
          }
        },
        tooltip: {
            trigger: "item",
            formatter: "{a} <br/>{b} : {c} ({d}%)",
            textStyle: {
                fontSize: 10
            }
        },
        legend: {
            orient: "vertical",
            x: "left",
            data: ["正常", "超前", "滞后", "办结"],
            textStyle: {
                fontSize: 10
            }
        },
        toolbox: {
        },
        calculable: true,
        series: [
            {
                name: "事项",
                type: "pie",
                radius: "50%",
                center: ["48%", "60%"],
                data: this.charts
            }
        ],
        color: ["rgb(46, 204, 190)", "rgb(86, 170, 255)", "rgb(243, 115, 68)", "rgb(150, 150, 150)"]
      };
      // alert(JSON.stringify(option))
      // 4.传入数据
      setTimeout(() =>{
        document.getElementById('charts1').setAttribute('_echarts_instance_', '')
        that.chart.setOption(option, true);
      },100);
    },
    clickMethod(id) {
      this.$router.push({  //核心语句
        path: '/projectlist',   //跳转的路径
        query:{id: id}
      })
    },
    chartClick(zt) {
      this.$router.push({  //核心语句
        path: '/projectlist',   //跳转的路径
        query:{type: 7, zt, name: '重点清单', selectYear: this.selectYear}
      })
    },
    onSearch(){
      if(this.value == ''){
        this.totalproject = this.initTotalproject
      } else {
        this.totalproject = this.initTotalproject.filter(item => {
          return item.name.indexOf(this.value) > -1
        })
      }
    },
    onClear(){
      this.totalproject = this.initTotalproject
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.selectClass {
  width: 100%;
  border-radius: 4px;
  border: 1px solid #C4C8CF;
  padding: 4px 0px 4px 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/Zdqd.vue